import { render, staticRenderFns } from "./add-file.vue?vue&type=template&id=4d07dc5d"
import script from "./add-file.vue?vue&type=script&lang=ts"
export * from "./add-file.vue?vue&type=script&lang=ts"
import style0 from "./add-file.vue?vue&type=style&index=0&id=4d07dc5d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports